import * as React from "react";
import { ITransaction } from "./ITransaction";
import { useTransaction } from "./useTransaction";
import { DataTable } from "../ui";

export function Inputs({ transaction }: { transaction: ITransaction }) {
  const url = "index.html?route=ADDRESS&address=";
  return (
    <DataTable
      headers={["Address", "Value"]}
      rows={transaction.vin.map((item: any, idx: number) => {
        if (item.coinbase) {
          let value = 0;
          transaction.vout.map((out) => (value += out.value));
          return ["Coinbase", value.toLocaleString() + " TLS"];
        }
        return [
          <a className="mono" href={url + item.address}>
            {item.address}
          </a>,
          item.value === 0 ? (
            <AssetData txid={item.txid} index={item.vout} />
          ) : (
            item.value.toLocaleString() + " TLS"
          ),
        ];
      })}
    />
  );
}

function AssetData({ txid, index }: { txid: string; index: number }) {
  const transaction = useTransaction(txid);
  if (!transaction) return <span className="dim">…</span>;
  const utxo = transaction.vout[index];
  const asset = utxo?.scriptPubKey?.asset;
  if (asset) return <span>{asset.amount} {asset.name}</span>;
  return null;
}
